import OrderFinancingType from "@/module/main/dto/OrderFinancingTypeEnum";
import IOrderFinancing from "@/module/main/dto/IOrderFinancing";
import IInstallmentSettings from "@/module/main/dto/IInstallmentSettings";
import IOperatingLeaseSettings from "@/module/main/dto/IOperatingLeaseSettings";
import IAmount from "@/module/main/dto/IAmount";

export default class OrderFinancing implements IOrderFinancing
{
    public readonly type: OrderFinancingType;
    public readonly amount?: IAmount;
    public readonly installment?: IInstallmentSettings;
    public readonly consumerLoan?: IInstallmentSettings;
    public readonly goodsFinancing?: IInstallmentSettings;
    public readonly operatingLease?: IOperatingLeaseSettings;

    constructor(props: IOrderFinancing)
    {
        this.type = props.type;
        this.amount = props.amount;
        this.installment = props.installment;
        this.consumerLoan = props.consumerLoan;
        this.goodsFinancing = props.goodsFinancing;
        this.operatingLease = props.operatingLease;
    }
}
